// An installer-links call carries a phone number, an email address and a name in its body, and the
// axios error and response objects hold that body (config.data). Logging them would put it in the browser
// console and, through Sentry's console breadcrumbs, in an error report.
const INSTALLER_LINKS = /^\/?(api\/v1\/)?installer-links(\/|$|\?)/;

type Loggable = {
    config?: { url?: string; method?: string };
    status?: number;
    message?: string;
    response?: { status?: number };
};

/** What may be logged for `value`: only method, url, status and message for an installer-links call; anything else unchanged. */
export function redactForLog<T>(value: T): T | { method?: string; url?: string; status?: number; message?: string } {
    const v = value as unknown as Loggable | undefined | null;
    const url = v && typeof v === 'object' ? v.config?.url : undefined;
    if (!url || !INSTALLER_LINKS.test(url)) return value;
    return { method: v?.config?.method, url, status: v?.response?.status ?? v?.status, message: v?.message };
}
